'use client';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function PrequalResultError() {
  return (
    <Box
      id="prequal-result"
      sx={{ containerType: 'inline-size', minWidth: '250px' }}
    >
      <Stack
        component="aside"
        sx={{
          gap: 4,
          padding: '24px 32px',
          border: '1px solid #CCD0D6',
          borderRadius: '24px',
          alignItems: 'flex-start',
          '@media (min-width:600px)': {
            flexDirection: 'row',
            alignItems: 'center',
            borderRadius: '32px',
          },
        }}
      >
        <Stack sx={{ gap: 2, flex: '1 0 0' }}>
          <Typography variant="h6" component="h2">
            Financing info unavailable
          </Typography>
          <Alert icon={false} severity="warning" sx={{ width: 'fit-content' }}>
            We ran into a technical error on our end.
          </Alert>
        </Stack>
        <Button
          fullWidth
          onClick={() => window.location.reload()}
          variant="contained"
          sx={{ '@media (min-width:600px)': { width: 'auto' } }}
        >
          Try again
        </Button>
      </Stack>
    </Box>
  );
}
